import { Page, PageContainer } from '@/modules/report_server/domain/page'
import {nextTick} from '@/modules/report_server/infra/next_tick'
import Vue from 'vue'

export class Vue2PageContainer implements PageContainer {
    pages = Vue.observable([]);
    async addPage(page:Page):Promise<void> {
        return new Promise((resolve,reject)=>{
            nextTick(()=>{
                this.pages.push(page)
                resolve()
            })
        })
    }
    getPage(index:number):Page{
        if (!this.pages || index < 0 || index >= this.pages.length) {
            throw new Error(`Index out of bounds or pages not initialized: ${index}`);
        }
        return this.pages[index]
    }
    getNumPages(): number {
        return this.pages ? this.pages.length : 0
    }
    getAllPages() : Page[] {
        return this.pages ? this.pages : []
    }
    async setVisibleRange(start:number, end:number): Promise<void>{
        if (!this.pages) {
            throw new Error('Pages not initialized');
        }
        for(let index=0;index<this.pages.length;index++){
            await this.pages[index].setVisible(index>=start && index<=end)
        }
        return new Promise((resolve,reject)=>{
            
            nextTick(()=>{
                
                resolve()
            })
        })
    }
    refreshLastPage():Promise<void>{
        return new Promise((resolve,reject)=>{
            nextTick(()=>{ 
                const lastPage=this.pages[this.pages.length-1]
                this.pages.splice(this.pages.length-1,1)
                nextTick(()=>{
                    this.pages.push(lastPage)
                    resolve()
                })
            })
            
        })
        
    }
    refreshAllPages():Promise<void>{
        return new Promise((resolve,reject)=>{
            nextTick(()=>{
                const pagesCopy=this.pages.slice()
                this.pages.splice(0,this.pages.length)
                nextTick(()=>{
                    for(const page of pagesCopy){
                        this.pages.push(page)
                    }
                    resolve()
                })
            })
            
        })
    }
}